module.exports = __webpack_public_path__ + "static/media/comisaria.542f1d98.webp";